module.exports = __webpack_public_path__ + "static/media/call_with_james_barry.e89c1adc.jpg";